// eslint-disable-next-line import/prefer-default-export
export const PlatformExeptions = (platformName) => {
  let platform = platformName;
  switch (platform) {
    case 'lewagon':
      platform = 'LeWagon';
      break;
    case 'demo-universidades':
      platform = 'demo';
      break;
    case 'localhost':
      // platform = 'bolsadetrabajo';
      platform = 'demo';
      break;
    case 'ucpuebla':
      platform = 'cuahutemoc';
      break;
    case 'tecdeoriente':
      platform = 'utdo';
      break;
    case 'utlaguna':
      platform = 'utlagunadurango';
      break;
    case 'wadhwaniorg':
      platform = 'wadhwani';
      break;
    case 'imef':
      platform = 'imefu';
      break;
    case 'utm':
      platform = 'utmezquital';
      break;
    case 'bolsaexpansion.utel.edu.mx':
      platform = 'utel';
      break;
    case 'somosresilientes.savethechildren.mx':
      platform = 'savethechildren';
      break;
    case 'bolsa.savethechildren':
      platform = 'savethechildren';
      break;
    default:
      platform = platformName;
      break;
  }
  return platform;
};
